module.exports = __webpack_public_path__ + "img/exchange_green.0300514f.svg";